import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { CreatePromotionPage } from "@/features/ventes/components/tarifs/CreatePromotionPage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/promotions/create")({
  loader: requirePermission(TARIF_PERMISSIONS.PROMOTIONS_CREATE),
  staticData: {
    title: "Nouvelle promotion",
    showInBreadcrumb: true,
  },
  component: CreatePromotionPage,
});
